import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';

var _templateObject = _taggedTemplateLiteral([''], ['']);

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ReactionHeader from './ReactionHeader';
import RecurrencyModeSwitch from './RecurrencyModeSwitch';
import Review from './Review';
import injected from '../../../injected';
import { utils } from 'gipsy-misc';
import { CloseIcon } from '../../../Panel';

var Header = function (_PureComponent) {
  _inherits(Header, _PureComponent);

  function Header() {
    _classCallCheck(this, Header);

    return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
  }

  _createClass(Header, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          editMode = _props.editMode,
          mode = _props.mode,
          task = _props.task,
          reviewHeaderType = _props.reviewHeaderType,
          handleAPIError = _props.handleAPIError,
          progressPending = _props.progressPending,
          progressSuccess = _props.progressSuccess,
          progressError = _props.progressError,
          onChange = _props.onChange,
          onChangeReview = _props.onChangeReview,
          onEditModeChange = _props.onEditModeChange,
          closePanel = _props.closePanel,
          approveReview = _props.approveReview,
          reopenReview = _props.reopenReview;

      var _utils$task$getTaskDa = utils.task.getTaskDataForUser(task, injected.user),
          isAssignee = _utils$task$getTaskDa.isAssignee,
          hasReviewer = _utils$task$getTaskDa.hasReviewer,
          isReviewer = _utils$task$getTaskDa.isReviewer,
          reviewStatus = _utils$task$getTaskDa.reviewStatus;

      var assigneeName = task.to ? utils.user.getDisplayName(task.to) : undefined;

      var reactionsExist = task.reactions && task.reactions.length > 0;
      var shouldDisplayReview = hasReviewer;
      var shouldDisplayReactionHeader = editMode !== 'recurring' && task.completed === 1 && (reactionsExist || !isAssignee) && (!isReviewer || isReviewer && reviewStatus === utils.reviewstatus.reviewed);

      var reactions = void 0;
      if (isAssignee) {
        reactions = task.reactions;
      } else {
        reactions = task.reactions ? task.reactions.filter(function (r) {
          return r.from.userId === injected.user.id;
        }) : [];
      }

      var reviewers = task.watchers && task.watchers.filter(function (w) {
        return w.isReviewer;
      });

      return React.createElement(
        Container,
        { className: 'panel-header' },
        React.createElement(CloseIcon, { icon: 'Close', className: 'close-icon', onClick: closePanel }),
        shouldDisplayReactionHeader && React.createElement(ReactionHeader, { isAssignee: isAssignee, reactions: reactions, assignee: assigneeName, onChange: onChange }),
        shouldDisplayReview && React.createElement(Review, {
          review: task.review,
          reviewHeaderType: reviewHeaderType,
          onChange: onChange,
          onChangeReview: onChangeReview,
          reviewers: reviewers,
          handleAPIError: handleAPIError,
          progressPending: progressPending,
          progressSuccess: progressSuccess,
          progressError: progressError,
          approveReview: approveReview,
          reopenReview: reopenReview
        }),
        React.createElement(RecurrencyModeSwitch, {
          key: 'recurrency-mode-switch',
          editMode: editMode,
          mode: mode,
          task: task,
          onEditModeChange: onEditModeChange
        })
      );
    }
  }]);

  return Header;
}(PureComponent);

Header.propTypes = {
  onChange: PropTypes.func.isRequired,
  onChangeReview: PropTypes.func.isRequired,
  task: PropTypes.object,
  reviewHeaderType: PropTypes.string,
  onEditModeChange: PropTypes.func,
  mode: PropTypes.string,
  editMode: PropTypes.string,
  closePanel: PropTypes.func,
  handleAPIError: PropTypes.func,
  progressPending: PropTypes.func,
  progressSuccess: PropTypes.func,
  progressError: PropTypes.func,
  approveReview: PropTypes.func,
  reopenReview: PropTypes.func
};


export default Header;

var Container = styled.div(_templateObject);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/TaskPanel/components/Header/index.js
// module id = 1092
// module chunks = 0